import React, { useState } from "react";
import "./Sidebar.css";
import { NavLink, useLocation } from "react-router-dom";
import { MdDashboard, MdGroups } from "react-icons/md";
import { FaBuilding, FaTimes } from "react-icons/fa";
import { HiUserGroup } from "react-icons/hi";
import { AiOutlineProject } from "react-icons/ai";
import { BsListCheck } from "react-icons/bs";
import { IoBusinessOutline } from "react-icons/io5";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const userRole = localStorage.getItem("role");
  const location = useLocation();
  const [isWorkflowOpen, setIsWorkflowOpen] = useState(location.pathname.includes("workflowupdate"));

  const menuItems = [
    {
      path: "/admindashboard",
      icon: <MdDashboard />,
      label: "Dashboard",
      roles: ["admin"],
    },
    {
      path: "/dashboard",
      icon: <MdDashboard />,
      label: "Dashboard",
      roles: ["manager", "employee", "Team Leader"],
    },
    {
      path: "/clientcompany",
      icon: <FaBuilding />,
      label: "Client Company",
      roles: ["admin"],
    },
    // {
    //   path: "/admin",
    //   icon: <FaUserShield />,
    //   label: "Admin",
    //   roles: ["admin"],
    // },
    {
      path: "/department",
      icon: <IoBusinessOutline />,
      label: "Department",
      roles: ["admin"],
    },
    {
      path: "/project",
      icon: <AiOutlineProject />,
      label: "Project",
      roles: ["admin", "manager"],
    },
    {
      path: "/subteam",
      icon: <MdGroups />,
      label: "Project Members",
      roles: ["admin", "manager"],
    },
    {
      path: "/employee",
      icon: <HiUserGroup />,
      label: "Employee",
      roles: ["admin", "manager"],
    },
    {
      path: "/team",
      icon: <MdGroups />,
      label: "Team",
      roles: ["admin", "manager"],
    },
    {
      path: "/task",
      icon: <BsListCheck />,
      label: "Task",
      roles: ["manager", "admin","Team Leader"],
    },
    {
      path: "/workflowupdate/own",
      icon: <IoBusinessOutline />,
      label: "Workflow Update",
      roles: ["employee","Team Leader","manager"],
    },
  ];

  return (
    <>
      {/* Overlay for mobile when sidebar is open */}
      <div 
        className={`sidebar-overlay ${isSidebarOpen ? "open" : ""}`} 
        onClick={() => setIsSidebarOpen(false)}
      ></div>
      
      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="mobile-close-btn" onClick={() => setIsSidebarOpen(false)}>
          <FaTimes />
        </div>
        <div className="image">
          <img src="/images/Logo New (1).png" alt="Align Desk" />
        </div>
        <ul className="sidebar-menu">
          {menuItems
            .filter((item) => item.roles.includes(userRole))
            .map((item, index) => (
              <li key={index}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => (isActive && !item.path.includes("workflowupdate") ? "active" : (item.path.includes("workflowupdate") && window.location.pathname.includes("workflowupdate") ? "active" : ""))}
                  onClick={(e) => {
                    if (item.label === "Workflow Update" && (userRole === "manager" || userRole === "admin" || userRole === "Team Leader")) {
                      e.preventDefault();
                      setIsWorkflowOpen(!isWorkflowOpen);
                    } else {
                      if (window.innerWidth <= 768) setIsSidebarOpen(false);
                    }
                  }}
                >
                  {item.icon}
                  {item.label}
                </NavLink>
                {item.label === "Workflow Update" && (userRole === "manager" || userRole === "admin" || userRole === "Team Leader") && isWorkflowOpen && (
                  <div className="sub-menu">
                    <NavLink
                      to="/workflowupdate/own"
                      className={({ isActive }) => (isActive ? "active-sub sub-link" : "sub-link")}
                      onClick={() => setIsSidebarOpen(false)}
                    >
                      Own Workflow
                    </NavLink>
                    <NavLink
                      to="/workflowupdate/employee"
                      className={({ isActive }) => (isActive ? "active-sub sub-link" : "sub-link")}
                      onClick={() => setIsSidebarOpen(false)}
                    >
                      Employee Workflow
                    </NavLink>
                  </div>
                )}
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
